"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = KeyEmployeePageThree;
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _reactBootstrap = require("react-bootstrap");
var _KeyEmployeeFormsControl = require("./KeyEmployeeFormsControl");
var _PopoverAndOverlay = require("../Wizard/PopoverAndOverlay");
var _KeyEmployeeWizardCalc = require("./KeyEmployeeWizardCalc.config");
var _utils = require("../../middleware/utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function KeyEmployeePageThree() {
  // Pulling formik context from higher up, which gives us access to formik state
  var {
    values: {
      employees,
      aveGrossProfitPrior3YearsAmount,
      shortTermAssetsEstimates,
      industrySector
    }
  } = (0, _formik.useFormikContext)();
  (0, _react.useEffect)(() => {}, [employees]);

  // Auto-focus to snap scrolling to top of the stepper/progress bar if user travels back-and-forth between steps
  (0, _react.useEffect)(() => {
    document.getElementById(_KeyEmployeeWizardCalc.calcName).scrollIntoView();
    /* istanbul ignore else */
    if (window) {
      window.scrollBy(0, -112);
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "Businesses in your industry have an average return on assets of", ' ', /*#__PURE__*/_react.default.createElement("strong", null, roaDecimalToPercent(_KeyEmployeeWizardCalc.industryMap, industrySector, _KeyEmployeeWizardCalc.industrySectorROAPercent)), ".\xA0", /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    fieldName: 'Return on assets',
    text: _KeyEmployeeWizardCalc.popoverConfig.roaInfoText
  }), ' ', "With your average gross profit of", ' ', /*#__PURE__*/_react.default.createElement("strong", null, " $", aveGrossProfitPrior3YearsAmount, " "), " and short-term assets value of ", /*#__PURE__*/_react.default.createElement("strong", null, " $", shortTermAssetsEstimates), ", the estimated amount of profit you can attribute to your key employees as a whole is", ' ', /*#__PURE__*/_react.default.createElement("strong", null, calculateProfitAttributableToManagement(aveGrossProfitPrior3YearsAmount, shortTermAssetsEstimates, _KeyEmployeeWizardCalc.industryMap, industrySector, _KeyEmployeeWizardCalc.industrySectorROAPercent)), ".", ' ', /*#__PURE__*/_react.default.createElement(_PopoverAndOverlay.PopoverAndOverlay, {
    fieldName: 'Estimated profit',
    text: _KeyEmployeeWizardCalc.popoverConfig.estimatedProfitText
  })), /*#__PURE__*/_react.default.createElement("p", {
    className: "blank-spacer"
  }), /*#__PURE__*/_react.default.createElement("h3", {
    className: "data-lg"
  }, calculateProfitAttributableToManagement(aveGrossProfitPrior3YearsAmount, shortTermAssetsEstimates, _KeyEmployeeWizardCalc.industryMap, industrySector, _KeyEmployeeWizardCalc.industrySectorROAPercent)), /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-md-6"
  }, /*#__PURE__*/_react.default.createElement("strong", null, "Now that we've estimated how much profit your key employees generate as a group, let's look at each one of your key employees and the impact they have on your profits."))), /*#__PURE__*/_react.default.createElement("p", null), /*#__PURE__*/_react.default.createElement(_formik.FieldArray, {
    name: "employees"
  }, fieldArrayProps => {
    var {
      push,
      remove,
      form
    } = fieldArrayProps;
    var {
      values
    } = form;
    var {
      employees
    } = values;
    var employeeArray = employees.map((employee, index) => {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "key-employee-info-container "
      }, /*#__PURE__*/_react.default.createElement("h4", {
        className: "individual-key-employee-title "
      }, "My Key Employee ".concat(index + 1, " "), index > 0 && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
        variant: "none",
        className: "btn-inline",
        onClick: () => {
          remove(index);
        }
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "remove-key-employee-button-styling"
      }, "Remove"))), /*#__PURE__*/_react.default.createElement("div", {
        className: "row",
        key: index
      }, /*#__PURE__*/_react.default.createElement(_KeyEmployeeFormsControl.EmployeeIdentity, {
        errors: form.errors,
        touched: form.touched,
        fieldName: "employeeId",
        values: values,
        arrayName: "employees",
        index: index
      }), /*#__PURE__*/_react.default.createElement(_KeyEmployeeFormsControl.AnnualProfitAttributable, {
        errors: form.errors,
        touched: form.touched,
        fieldName: "annualProfitAttributable",
        values: values,
        arrayName: "employees",
        index: index
      }), /*#__PURE__*/_react.default.createElement(_KeyEmployeeFormsControl.ReplaceEmployeeYears, {
        errors: form.errors,
        touched: form.touched,
        fieldName: "replaceEmployeeYears",
        values: values,
        arrayName: "employees",
        index: index
      }))));
    });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, employeeArray, employees.length > 4 ? /*#__PURE__*/_react.default.createElement("p", null, "Max. of 5 employees allowed") : /*#__PURE__*/_react.default.createElement(_reactBootstrap.Button, {
      variant: "none",
      className: "btn-inline",
      onClick: () => {
        push('');
      }
    }, /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("span", {
      className: "icon-add"
    }), "\xA0Add Another Key Employee")));
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "blank-spacer"
  })));
}
function roaDecimalToPercent(industryMap, industrySector, industrySectorROAPercent) {
  return parseFloat(industrySectorROAPercent[industryMap[industrySector]] * 100).toFixed(2) + '%';
}
function calculateProfitAttributableToManagement(aveGrossProfitPrior3YearsAmount, shortTermAssetsEstimates, industryMap, industrySector, industrySectorROAPercent) {
  return (0, _utils.numberToCurrencyString)((0, _utils.parseCurrencyString)(null, aveGrossProfitPrior3YearsAmount) - (0, _utils.parseCurrencyString)(null, shortTermAssetsEstimates) * industrySectorROAPercent[industryMap[industrySector]]);
}